export const MEMO_TYPES = {
  HOLD: 'HOLD',
  DEAL: 'DEAL'
};
